import React, { useCallback, useEffect, useState } from "react";
import {
  Form,
  // Modal,
  Button,
  Col,
  InputGroup,
  FormControl,
  Row,
  Tabs,
  Tab,
  Offcanvas,
} from "react-bootstrap";
import { withCookies } from "react-cookie";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  addTask,
  updateTask,
  archiveTask,
  unArchiveTask,
} from "../../redux/actions/tasks";
import configVars from "../../config";
import AllComments from "../Comments/AllComments";
import History from "../History";

// Images
import noCommentImg from "../../images/noComment.png";
import PromptBox from "../PromptBox";

const Implementation = ({
  setApiLoading,
  show,
  handleClose,
  selectedTask,
  board,
  columnId,
  selectedColumn,
  droppableColumn,
  config,
  handleArchive,
  draggableColumn,
  handleUnarchive,
  handleDelete,
  getColumnNo,
  columnTitle,
  setShowCloseConfirmation,
  resetInitially,
  showArchiveButtons = true,
}) => {
  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");

  const allTaskTypes = config && config["task_type"];
  const allTaskStatus = config && config["task_status"];
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [showUpdateBtn, setShowUpdateBtn] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [displayPrompt, setDisplayPrompt] = useState(false);
  const [action, setAction] = useState("");
  const [steps, setSteps] = useState("");
  const [support, setSupport] = useState("");
  const [benefits, setBenefits] = useState("");
  const [actionContent, setActionContent] = useState("");
  const [stepsContent, setStepsContent] = useState("");
  const [supportContent, setSupportContent] = useState("");
  const [benefitsContent, setBenefitsContent] = useState("");
  const [taskType, setTaskType] = useState(
    allTaskTypes ? Object.keys(allTaskTypes)[0] : null
  );
  const [status, setStatus] = useState("");
  const [showClearStatus, setShowClearStatus] = useState(false);
  const [timeline, setTimeline] = useState({
    startDate: selectedTask?.implementation_timeline_start
      ? moment(new Date(selectedTask?.implementation_timeline_start)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
    endDate: selectedTask?.implementation_timeline_end
      ? moment(new Date(selectedTask?.implementation_timeline_end)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
  });
  const [datePickerKey, setDatePickerKey] = useState(0);
  const allComments = selectedTask?.comments ? selectedTask.comments : [];

  const resetState = useCallback(() => {
    setTitle({ value: "", error: false });
    setAction("");
    setTaskType(allTaskTypes ? Object.keys(allTaskTypes)[0] : null);
    setStatus("");
    setStepsContent(null);
    setBenefitsContent(null);
    setSupportContent(null);
    setActionContent(null);
    setSteps(null);
    setBenefits(null);
    setSupport(null);
    setAction(null);
    setUsers([]);
    setTimeline({});
  }, [allTaskTypes]);

  useEffect(() => {
    setSteps(null);
    setBenefits(null);
    setSupport(null);
    setAction(null);
    setStepsContent(null);
    setBenefitsContent(null);
    setSupportContent(null);
    setActionContent(null);
  }, [selectedTask]);

  useEffect(() => {
    if (resetInitially) {
      resetState();
    }
  }, [show, resetInitially, resetState]);

  useEffect(() => {
    if (selectedTask && show) {
      setTitle({ value: selectedTask.title, error: false });
      setTimeline((tl) => ({
        ...tl,
        startDate: selectedTask?.implementation_timeline_start
          ? moment(
              new Date(selectedTask?.implementation_timeline_start)
            ).format("MM/DD/YYYY")
          : moment(new Date()).format("MM/DD/YYYY"),
        endDate: selectedTask?.implementation_timeline_end
          ? moment(new Date(selectedTask?.implementation_timeline_end)).format(
              "MM/DD/YYYY"
            )
          : moment(new Date()).format("MM/DD/YYYY"),
      }));
      setDatePickerKey((k) => k + 1);
      let implementation_decided_action = null;
      if (selectedTask?.action_plan_decided_action) {
        implementation_decided_action =
          selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        implementation_decided_action =
          selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        implementation_decided_action =
          selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        implementation_decided_action = selectedTask?.evaluation_result;
      }

      if (implementation_decided_action) {
        const contentBlock1 = htmlToDraft(implementation_decided_action);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setAction(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setActionContent(_contentState);
        } else {
          setAction(null);
          setActionContent(null);
        }
      }
      let concrete_steps = selectedTask?.concrete_steps;

      if (concrete_steps) {
        const contentBlock1 = htmlToDraft(concrete_steps);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setSteps(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setStepsContent(_contentState);
        } else {
          setSteps(null);
          setStepsContent(null);
        }
      }
      let resources_and_support = selectedTask?.resources_and_support;

      if (resources_and_support) {
        const contentBlock1 = htmlToDraft(resources_and_support);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setSupport(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setSupportContent(_contentState);
        } else {
          setSupport(null);
          setSupportContent(null);
        }
      }
      let benefits = selectedTask?.benefits;

      if (benefits) {
        const contentBlock1 = htmlToDraft(benefits);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setBenefits(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setBenefitsContent(_contentState);
        } else {
          setBenefits(null);
          setBenefitsContent(null);
        }
      }
      if (selectedTask?.responsible_persons) {
        setUsers(selectedTask?.responsible_persons);
      }

      setStatus(selectedTask?.task_status?.term_id);
      setTaskType(selectedTask?.task_type?.term_id);
    }
  }, [selectedTask, show]);
  useEffect(() => {
    if (board) {
      setAllUsers(board?.associated_users);
    }
  }, [board]);

  const handleChange = (value, field) => {
    if (setShowCloseConfirmation) {
      setShowCloseConfirmation(true);
    }
    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
    if (field === "title") {
      setTitle({ value: value, error: false });
    } else if (field === "action") {
      setAction(value);
    } else if (field === "steps") {
      setSteps(value);
    } else if (field === "support") {
      setSupport(value);
    } else if (field === "benefits") {
      setBenefits(value);
    }
  };

  const handleSubmit = async (action, archive) => {
    if (!title?.value) {
      setTitle({ ...title, error: true });
      return;
    }

    let selectedUsers = [];
    users && users.forEach((user) => selectedUsers.push(user.id));
    try {
      setLoading(true);
      let tasklist_id = droppableColumn
        ? droppableColumn
        : selectedColumn
        ? selectedColumn
        : columnId
        ? columnId
        : null;

      let taskObject = {
        board_id: parseInt(params?.board_id),
        title: title?.value,
        tasklist_id: tasklist_id ? parseInt(tasklist_id) : null,
        implementation_decided_action: draftToHtml(actionContent),
        concrete_steps: draftToHtml(stepsContent),
        resources_and_support: draftToHtml(supportContent),
        benefits: draftToHtml(benefitsContent),
        implementation_timeline_start: moment(timeline?.startDate).format(
          "YYYY/MM/DD"
        ),
        implementation_timeline_end: moment(timeline?.endDate).format(
          "YYYY/MM/DD"
        ),
        task_type: taskType,
        task_status: status,
        task_responsible_person: selectedUsers,
        post_status: "publish",
      };

      if (action === "create") {
        taskObject["parent_task_id"] = selectedTask?.id
          ? selectedTask?.id
          : null;
        await dispatch(
          addTask({
            data: taskObject,
            columnId: droppableColumn ? droppableColumn : columnId,
          })
        );
        if (archive) {
          let archiveTaskObject = {
            id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
            post_status: "archive",
          };

          await dispatch(
            archiveTask({
              data: archiveTaskObject,
              columnId: draggableColumn,
              task: selectedTask,
            })
          );
        }
      } else {
        if (selectedColumn) {
          if (!taskObject.implementation_decided_action) {
            delete taskObject["implementation_decided_action"];
          }
          if (!taskObject.concrete_steps) {
            delete taskObject["concrete_steps"];
          }
          if (!taskObject.resources_and_support) {
            delete taskObject["resources_and_support"];
          }
          if (!taskObject.benefits) {
            delete taskObject["benefits"];
          }

          taskObject["id"] = selectedTask?.id;

          if (!taskObject["board_id"]) {
            taskObject["board_id"] = selectedTask["board_id"];
          }

          await dispatch(
            updateTask({ data: taskObject, columnId: selectedColumn })
          );
        }
      }
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDateRange = (start, end, label) => {
    setTimeline({
      startDate: start.format("MM/DD/YYYY"),
      endDate: end.format("MM/DD/YYYY"),
    });
    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
  };
  const handleArchiveCard = async () => {
    try {
      setLoading(true);

      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "archive",
      };
      await dispatch(
        archiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const handleUnarchiveCard = async () => {
    try {
      setLoading(true);
      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "publish",
      };
      await dispatch(
        unArchiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const _handleCloseLocal = () => {
    if (showUpdateBtn || showSaveBtn) {
      setDisplayPrompt(true);
    } else {
      setDisplayPrompt(false);
      handleClose();
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        _handleCloseLocal();
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      fullscreen={"sm-down"}
      backdrop
      style={{ margin: "0rem", width: "70%" }}
      placement="end"
    >
      <Offcanvas.Header className="p-1" closeButton>
        <Offcanvas.Title className="font-weight-bold" style={{ width: "100%" }}>
          <Col
            lg="6"
            className="d-flex justify-content-between align-item-center m-2"
          >
            <h3 className="d-flex mb-0 align-items-center">
              <span className="d-flex align-items-center mx-2  justify-content-center  bg-light-green text-white title-number-background">
                4
              </span>
              {columnTitle}
            </h3>
            {showSaveBtn && !selectedTask ? (
              <Button
                style={{
                  height: "43px",
                  fontSize: "13px",
                }}
                variant="light-green text-white rounded px-3 mx-3"
                onClick={() => handleSubmit("create")}
                disabled={loading}
                className="save-new-card"
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.save")
                )}
              </Button>
            ) : null}
            {showUpdateBtn && selectedTask && !droppableColumn ? (
              <Button
                style={{
                  height: "32px",
                  padding: "0px 0px",
                  fontSize: "13px",
                }}
                variant="light-green text-white rounded"
                onClick={() => handleSubmit("update")}
                className="mx-3 px-3 pull-right update-selected"
                disabled={loading}
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.update")
                )}
              </Button>
            ) : null}
          </Col>
          <Col lg="6"></Col>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 implementation">
        {setApiLoading ? (
          <div className="container-fluid px-3">
            <div className="d-flex justify-content-center mt-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </div>
        ) : (
          <Row>
            <Col lg="6" style={{ overflowY: "scroll", height: "100vh" }}>
              <Form>
                <div className="">
                  <div className="d-lg-flex flex-lg-column">
                    <Form.Group className=" pt-2">
                      <Form.Label>
                        <b className="text-capitalize">
                          {translation("title")}
                        </b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={title?.value
                          ?.substring(0, 45)
                          .replaceAll("&amp;", "&")}
                        onChange={(e) => handleChange(e.target.value, "title")}
                        isInvalid={title?.error}
                        style={{
                          fontSize: "14px",
                          padding: "0.5rem 0.5rem",
                          borderRadius: "0px",
                        }}
                      />
                      {title?.error && (
                        <Form.Control.Feedback type="invalid">
                          {translation("title_empty_warning")}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    <Form.Group style={{ marginTop: "20px", width: "100%" }}>
                      <Form.Label>
                        <b>
                          {translation("task_forms.action_plan.field2.label")}
                        </b>
                      </Form.Label>
                      <Typeahead
                        id="basic-typeahead-multiple"
                        labelKey="display_name"
                        multiple
                        onChange={(e) => {
                          setUsers(e);
                          if (setShowCloseConfirmation) {
                            setShowCloseConfirmation(true);
                            setShowUpdateBtn(true);
                          }
                        }}
                        options={allUsers}
                        placeholder={translation(
                          "task_forms.action_plan.field2.placeholder"
                        )}
                        selected={users}
                        className="responsible-users"
                        inputProps={{
                          className: "custom-user-input",
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="d-flex justify-content-center">
                    {config &&
                      allTaskTypes &&
                      Object.keys(allTaskTypes)?.map((item, index) => {
                        return (
                          <Col className="d-flex px-2" key={index}>
                            <Button
                              variant={
                                parseInt(taskType) === parseInt(item)
                                  ? "light-green"
                                  : "outline-light-green"
                              }
                              className={`${
                                parseInt(taskType) === parseInt(item)
                                  ? `text-white`
                                  : `text-black`
                              } rounded`}
                              style={{
                                width: "100%",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                              onClick={() => {
                                setTaskType(item);
                              }}
                            >
                              {allTaskTypes[item]?.name}
                            </Button>
                          </Col>
                        );
                      })}
                  </div>

                  <div className=" mt-4">
                    <InputGroup className="mb-2">
                      <Form.Label style={{ width: "100%" }}>
                        <b>
                          {translation("task_forms.action_plan.field3.label")}
                        </b>
                      </Form.Label>

                      <InputGroup.Text>
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                      </InputGroup.Text>
                      <DateRangePicker
                        key={datePickerKey}
                        onCallback={handleDateRange}
                        initialSettings={timeline}
                        onApply={() => {
                          if (setShowCloseConfirmation) {
                            setShowCloseConfirmation(true);
                          }
                        }}
                      >
                        <FormControl
                          style={{ borderRadius: "0px" }}
                          type="text"
                          placeholder={translation("add_time_period")}
                        />
                      </DateRangePicker>
                    </InputGroup>
                  </div>
                  {/* </Col> */}
                </div>

                <div className="d-flex mt-3">
                  <Form.Label>
                  <div className="d-flex">
                      <div className="col">
                        <b>{translation("status")}</b>
                      </div>
                      {showClearStatus &&
                        <div className="col-auto">
                          <button type="button" className="btn btn-link py-0 text-action-blue ms-3 font-size-medium" onClick={() => {setShowClearStatus(false);setStatus('');}}>
                            <i className="fa fa-trash"></i>
                            <span className="ps-2">Tömma <span className="text-lowercase">{translation("status")}</span></span>
                          </button>
                        </div>
                      }
                    </div>
                  </Form.Label>
                </div>
                <div className="d-flex ">
                  {config &&
                    allTaskStatus &&
                    Object.keys(allTaskStatus)?.map((item, index) => {
                      return (
                        <div
                          className="d-flex justify-content-left"
                          key={index}
                        >
                          <button
                            style={{
                              height: "32px",
                              width: "90px",
                              padding: "0px 0px",
                              fontSize: "13px",
                              borderRadius: "32px",
                              marginRight: "10px",
                            }}
                            type="button"
                            className={` btn border-1 ${
                              status === allTaskStatus[item].term_id
                                ? `btn-sy-${allTaskStatus[item].slug} text-white`
                                : `btn-outline-sy-${allTaskStatus[item]?.slug}`
                            }`}
                            onClick={() => {
                              setStatus(allTaskStatus[item].term_id);
                              if (setShowCloseConfirmation) {
                                setShowUpdateBtn(true);
                                setShowCloseConfirmation(true);
                                setShowClearStatus(true);
                              }
                            }}
                          >
                            {allTaskStatus[item]?.name}
                          </button>
                        </div>
                      );
                    })}
                </div>

                <Form.Group className=" mt-3">
                  <Form.Label>
                    <b>{translation("task_forms.action_plan.field6.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={action}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "action")}
                    onChange={(e) => {
                      setActionContent(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("concrete_steps")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={steps}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "steps")}
                    onChange={(e) => {
                      setStepsContent(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("resources_support")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={support}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "support")}
                    onChange={(e) => {
                      setSupportContent(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("benefits")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={benefits}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "benefits")}
                    onChange={(e) => {
                      setBenefitsContent(e);
                    }}
                  />
                </Form.Group>
              </Form>
              <div>
                {selectedTask && droppableColumn ? (
                  <Row>
                    <div className="me-5 task-moved">
                      <Button
                        variant="light-green text-white rounded"
                        onClick={() => handleSubmit("create", false)}
                        disabled={loading}
                        className="mb-2"
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text3"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>

                      <Button
                        variant="light-green text-white rounded"
                        onClick={() => handleSubmit("create", true)}
                        disabled={loading}
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text4"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>
                    </div>
                  </Row>
                ) : selectedTask && selectedColumn ? (
                  <div className="d-flex task-btns" style={{ width: "100%" }}>
                    <div className="update-exist">
                      <Button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          marginRight: "10px",
                        }}
                        variant="light-green text-white rounded px-3"
                        onClick={() => handleSubmit("update")}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.update")
                        )}
                      </Button>
                    </div>
                    <div className="archive-delete">
                      {selectedTask?.post_status === "publish" &&
                      showArchiveButtons ? (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            marginRight: "10px",
                          }}
                          variant="light-green text-white rounded px-3"
                          onClick={() => {
                            handleArchiveCard();
                          }}
                          className="archive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.archive_card")
                          )}
                        </Button>
                      ) : showArchiveButtons ? (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            marginRight: "10px",
                          }}
                          variant="light-green text-white rounded px-3"
                          onClick={() => {
                            handleUnarchiveCard();
                          }}
                          className="unarchive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.unarchive_card")
                          )}
                        </Button>
                      ) : (
                        <></>
                      )}
                      <Button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          marginRight: "10px",
                        }}
                        variant="light-green text-white rounded px-3"
                        onClick={() => handleDelete()}
                        className="delete-card"
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.delete_card")
                        )}
                      </Button>
                      <div className="mb-5" />
                    </div>
                  </div>
                ) : (
                  <Button
                    style={{
                      height: "43px",
                      fontSize: "13px",
                      marginRight: "10px",
                    }}
                    variant="light-green text-white rounded px-3"
                    onClick={() => handleSubmit("create")}
                    disabled={loading}
                    className="save-card"
                  >
                    {loading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      translation("buttons.save")
                    )}
                  </Button>
                )}
              </div>
            </Col>
            <Col lg="6" className="p-0">
              {!selectedTask ? (
                <div className="d-flex justify-content-center align-items-center h-100 new-card-comment">
                  <img
                    src={noCommentImg}
                    alt="No-Comments"
                    style={{ width: "200px" }}
                  />
                </div>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey="commentsKey"
                    id="uncontrolled-tab-example"
                    className="mb-3 sustain-tabs bg-white"
                    fill
                  >
                    <Tab
                      eventKey="commentsKey"
                      title={translation("task_forms.comments.commentsHeading")}
                    >
                      {selectedTask && droppableColumn ? (
                        <div className="d-flex justify-content-center align-items-center no-comments-container">
                          <img
                            src={noCommentImg}
                            alt="No-Comments"
                            style={{ width: "200px" }}
                          />
                        </div>
                      ) : (
                        <AllComments
                          task_id={selectedTask?.id}
                          color="light-green"
                          taskComments={allComments}
                          tasklist_id={
                            columnId
                              ? columnId
                              : droppableColumn
                              ? droppableColumn
                              : selectedColumn
                              ? selectedColumn
                              : null
                          }
                        />
                      )}

                      {/* </div> */}
                    </Tab>
                    <Tab eventKey="history" title={translation("history")}>
                      <div className="col-12 px-2">
                        <History
                          taskDate={selectedTask.task_date}
                          history={selectedTask?.history}
                          getColumnNo={getColumnNo}
                          config={config}
                          board={board}
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </>
              )}
            </Col>
            <PromptBox
              show={displayPrompt}
              handleClosePrompt={() => {
                setShowCloseConfirmation(false);
                setShowUpdateBtn(false);
                setShowSaveBtn(false);
                setTimeout(() => {
                  setDisplayPrompt(false);
                  handleClose();
                });
              }}
              title={"Changes are not saved"}
              message={translation("select_changes")}
              handleClose={() => {
                setDisplayPrompt(false);
              }}
              handleSave={() => {
                if (selectedTask) {
                  handleSubmit("update");
                } else {
                  handleSubmit("create");
                }
              }}
              isLoading={loading}
            />
          </Row>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default withCookies(Implementation);
